import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginPage from "./pages/loginPage";
import Layout from "./Layouts/Layout";
import Employee from "./pages/Employee";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OpenModal from "./Components/popup/openModal";
import { SocketProvider } from "./context/SocketProvider";
import WebSocketHandler from "./ui/WebSocketHandler ";
import HomePage from "./pages/HomePage";
import PrivateRoutes from "./Components/auth/PrivateRoutes";
import { connect } from "extendable-media-recorder-wav-encoder";
import AttendanceDashboard from "./pages/EmployeeDetails";
import Lecture from "./pages/AudioScreenMic";
import LiveCameraDraw from "./pages/LiveCameraDraw";
import { register } from "extendable-media-recorder";
import CameraGroupPage from "./pages/Camera/CameraGroupPage";
import CameraListing from "./pages/Camera/CameraListing";
import UserConfiguration from "./pages/UserConfigure/UserConfigure";
import AddStudentBasicInfo from "./pages/AddStudent";
import CreateCameraGroup from "./pages/Camera/CreateCameraGroup";
import DeviceListing from "./pages/Camera/DeviceListing";
import { ToastContainer } from "react-toastify";
import { Bounce } from "react-toastify";
import CheckinCheckoutRecord from "./pages/Event/EventDetail/CheckinCheckoutRecord";
import LiveAttendence from "./pages/Event/Attendence/LiveAttendence";
import AttendenceRecord from "./pages/Event/Attendence/AttendenceRecord";
import AddStudentForm from "./pages/AddStudent";
import Controllers from "./pages/Devices/Controllers";
import Rooms from "./pages/Rooms";
import SetSection from "./pages/SetSection";
import DoorRecord from "./pages/Event/Door/DoorRecord";
import Numberplat from "./Components/Numberplat";
import AttendanceVideo from "./pages/Usecases/AttendanceVideo";
import CheckinCheckoutVideo from "./pages/Usecases/CheckinCheckoutVideo";
import RestrictionZoneVideo from "./pages/Usecases/RestrictionZoneVideo";
import NumberPlateVideo from "./pages/Usecases/NumberPlateVideo";
import DoorControlVideo from "./pages/Usecases/DoorControlVideo";
import LectureAnalysisVideo from "./pages/Usecases/LectureAnalysisVideo";
import TranscriptGnVideo from "./pages/Usecases/TranscriptGnVideo";
import UploadFileAudio from "./Components/UploadAudioFile/UploadFileAudio";
import RecordingHistory from "./pages/RecordingHistory";
import LectureTranscriptHistory from "./pages/LectureTranscriptHistory";
import SetDemo from "./pages/SetDemo";
import UseCaseMap from "./pages/Event";
import EventData from "./pages/Event/EventTable";
import LiveCheckingCheckout from "./pages/Event/EventDetail";
import EventDetail from "./pages/Event/EventDetail/EventDetail";
import AttendenceDetail from "./pages/Event/EventDetail/AttendenceDetail";
import CheckinCheckoutDetails from "./pages/Event/EventDetail/CheckinCheckoutDetails";
import Setlinetrack from "./pages/RamaUser/RamaUniversity/Setlinetrack";
import RamaLogs from "./pages/RamaUser/RamaUniversity/RamaLogs";
import Mess from "./pages/RamaUser/RamaUniversity/Mess";
import NumberPlatDetail from "./pages/Event/EventDetail/NumberPlatDetail";
import DoorDetectionDetail from "./pages/Event/EventDetail/DoorDetectionDetail";
import RamaMessDashbord from "./pages/RamaUser/RamaUniversity/RamaMessDashbord";
import MultiplePolygons from "./pages/SetMultiplePolygon";
import InviteUser from "./pages/InviteUser";
import CameraPlayer from "./pages/CameraPlayer";
import SetSeatdetection from "./pages/SetSeatdetection";
import TeamMember from "./pages/TeamMember";
import VideoWall from "./pages/VideoWall";
import CreateEventWrapper from "./pages/Event/CreateNewEvent/CreateEventWrapper";
import RamaCheckingDashboard from "./pages/RamaUser/RamaUniversity/RamaCheckingDashboard";
import RamaEventData from "./pages/RamaUser/RamaEvent";
import Students from "./pages/RamaUser/Student";
import EventList from "./pages/CrowdDetection/EventList";
import CrowdEventDetail from "./pages/CrowdDetection/EventDetail";
import UseCaseEvent from "./pages/UseCaseEvents";
import EventLogs from "./pages/UseCaseEvents/EventLogs";
import StepTwo from "./pages/Event/CreateNewEvent/StepTwoSeat";
import EditEventWrapper from "./pages/Event/CreateNewEvent/EditEventWrapper";
import CameraEventById from "./pages/CameraEventById";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Report from "./Components/Reports";
import Notifications from "./pages/Notifications/NotificationPage";
import Usecase from "./pages/Usecase";

const registerEncoder = async () => {
  await register(await connect());
};
registerEncoder();

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const PopupReducer = useSelector((state) => state.PopupReducer);
  const { showModal } = PopupReducer?.modal || {};
  const { data } = useSelector((state) => state?.authUser?.data);
  const ramaUser = "687f6c6fc14ca8470b40b732";
  const shardaUser = "687f6cddc14ca8470b40b734";

  useEffect(() => {
    setShowPopup(!!showModal);
    return () => {
      setShowPopup(false);
    };
  }, [showModal]);

  const routes = createBrowserRouter([
    {
      index: true,
      element: <HomePage />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/",
      element: <PrivateRoutes />,
      children: [
        {
          path: "/",
          element: <Layout />,
          children: [
            {
              path: "/dashboard",
              element:
                data?.user_id === ramaUser ? (
                  <Setlinetrack />
                ) : (
                  <CameraGroupPage />
                ),
            },
            {
              path: "/",
              element: (
                <PrivateRoutes>
                  {data?.user_id === ramaUser ||
                  data?.user_id === shardaUser ? (
                    <Setlinetrack />
                  ) : (
                    <HomePage />
                  )}
                </PrivateRoutes>
              ),
            },

            {
              path: "/dashboard",
              element:
                data?.user_id === ramaUser ? (
                  <Setlinetrack />
                ) : (
                  <CameraGroupPage />
                ),
            },
            { path: "/employee", element: <Employee /> },
            { path: "/employee/:id", element: <AttendanceDashboard /> },
            { path: "/camera", element: <CameraListing /> },
            { path: "/camera-group", element: <CameraGroupPage /> },
            { path: "/create-camera-group", element: <CreateCameraGroup /> },
            { path: "/event-details", element: <LiveCheckingCheckout /> },
            { path: "/usecase-mapping", element: <UseCaseMap /> },
            { path: "/device-type", element: <DeviceListing /> },
            { path: "/add-user", element: <AddStudentForm /> },
            { path: "/controllers", element: <Controllers /> },
            { path: "/add-user", element: <AddStudentBasicInfo /> },
            { path: "/lecture-analyse", element: <RecordingHistory /> },
            { path: "/user-configure", element: <UserConfiguration /> },
            { path: "/AudioScreenMic", element: <Lecture /> },
            { path: "/camera/ristriction", element: <LiveCameraDraw /> },
            { path: "/edit-student/:id", element: <AddStudentBasicInfo /> },
            {
              path: "/checkin-checkout-record",
              element: <CheckinCheckoutRecord />,
            },
            { path: "/live-attendence", element: <LiveAttendence /> },
            { path: "/record-attendence", element: <AttendenceRecord /> },
            { path: "/room", element: <Rooms /> },
            { path: "/setsection", element: <SetSection /> },
            { path: "/setdemo", element: <SetDemo /> },

            { path: "/setsection/:id", element: <SetSection /> },
            { path: "/door-log", element: <DoorRecord /> },
            {
              path: "/Lecture-trascript-history",
              element: <LectureTranscriptHistory />,
            },
            { path: "/lecture-convertor", element: <UploadFileAudio /> },
            { path: "/numberplat", element: <Numberplat /> },
            { path: "/attendance-videos", element: <AttendanceVideo /> },
            {
              path: "/checkin-checkout-videos",
              element: <CheckinCheckoutVideo />,
            },
            {
              path: "/restricted-zones-videos",
              element: <RestrictionZoneVideo />,
            },
            { path: "/number-plate-videos", element: <NumberPlateVideo /> },
            { path: "/door-control-videos", element: <DoorControlVideo /> },
            {
              path: "/lecture-analysis-videos",
              element: <LectureAnalysisVideo />,
            },
            {
              path: "/transcript-generation-videos",
              element: <TranscriptGnVideo />,
            },
            { path: "/event", element: <EventData /> },
            { path: "/event-detail/:id", element: <EventDetail /> },
            {
              path: "/check-in-out-details",
              element: <CheckinCheckoutDetails />,
            },
            {
              path: "/event-details/attendence",
              element: <AttendenceDetail />,
            },
            {
              path: "/event-details/number-plat",
              element: <NumberPlatDetail />,
            },
            {
              path: "/event-details/door-detection",
              element: <DoorDetectionDetail />,
            },
            {
              path: "/create-new-event",
              element: <CreateEventWrapper />,
              // <CreatNewEvent />
            },
            {
              path: "/edit-event/:id",
              element: <EditEventWrapper />,
              // <CreatNewEvent />
            },

           
           { path: "/usecase", element: <Usecase /> },
            { path: "/Setlinetrack", element: <Setlinetrack /> },
            { path: "/rama-logs", element: <RamaLogs /> },
            {
              path: "/rama-logs-dashboard",
              element: <RamaCheckingDashboard />,
            },
            { path: "/rama-events", element: <RamaEventData /> },

            { path: "/mess-ditection", element: <Mess /> },
            { path: "/events-details", element: <CameraPlayer /> },
            { path: "/video-wall", element: <VideoWall /> },
            {
              path: "/rama-mess-logs-dashboard",
              element: <RamaMessDashbord />,
            },
            {
              path: "/rama-students",
              element: <Students />,
            },

            // { path: "/ShardaMess-detection", element: <ShardMessDetect /> },
            { path: "/ShardMessDetect", element: <MultiplePolygons /> },
            { path: "/invite-user", element: <InviteUser /> },

            { path: "/seat-detection/:id", element: <SetSeatdetection /> },
            { path: "/team-member", element: <TeamMember /> },
            { path: "/crowd-detection", element: <EventList /> },
            { path: "/crowd-event-logs/:id", element: <CrowdEventDetail /> },
            { path: "/usecase-events", element: <UseCaseEvent /> },
            {
              path: "/usecase-events-logs/:id/:usecasename",
              element: <EventLogs />,
            },
            { path: "/steptwo", element: <StepTwo /> },
            { path: "/reports", element: <Report /> },
            { path: "/camera-event/:id", element: <CameraEventById /> },
            { path: "/notifications", element: <Notifications /> },
          ],
        },
      ],
    },

    {
      path: "/invite/:id",
      element: <LoginPage />,
    },
    {
      path: "/sign-in",
      element: <LoginPage />,
    },
  ]);

  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <SocketProvider>
        <WebSocketHandler />
        {showPopup && <OpenModal />}
        <RouterProvider router={routes} />
      </SocketProvider>
    </>
  );
}

export default App;
